<template>
  <div id="main">
    <myheader></myheader>
    <div class="shanzi">
      <img src="~@/assets/home_img/believeme.png" id="believe">
      <img src="~@/assets/home_img/life.png" id="life">
    </div>
    <div class="beianhao">
      <el-link href="https://beian.miit.gov.cn/" target="_blank">备案号：京ICP备18005572号</el-link>
    </div>
  </div>
</template>
<script>
import myheader from '../header/header.vue'
export default{
  name: 'home',
  components: { myheader }
}
</script>
<style scoped>
@keyframes bg{
  0%{background-image: url('~@/assets/home_img/star1.png');opacity: 1;background-repeat: no-repeat;background-size:cover ;}
  28%{background-image: url('~@/assets/home_img/star1.png');opacity: 1;background-repeat: no-repeat;background-size:cover ;}
  /* 29%{background-image: url('~@/assets/home_img/star1.png');opacity: 0;background-repeat: no-repeat;background-size:cover ;} */
  30%{background-image: url('~@/assets/home_img/star2.jpg');opacity: 1;background-repeat: no-repeat;background-size:cover ;}
  63%{background-image: url('~@/assets/home_img/star2.jpg');opacity: 1;background-repeat: no-repeat;background-size:cover ;}
  /* 64%{background-image: url('~@/assets/home_img/star2.jpg');opacity: 0;background-repeat: no-repeat;background-size:cover ;} */
  65%{background-image: url('~@/assets/home_img/star3.jpg');opacity: 1;background-repeat: no-repeat;background-size:cover ;}
  98%{background-image: url('~@/assets/home_img/star3.jpg');opacity: 1;background-repeat: no-repeat;background-size:cover ;}
  /* 99%{background-image: url('~@/assets/home_img/star3.jpg');opacity: 0;background-repeat: no-repeat;background-size:cover ;} */
  100%{background-image: url('~@/assets/home_img/star1.png');opacity: 1;background-repeat: no-repeat;background-size:cover ;}
}
@keyframes ss{
  0%{opacity: 0;}
  10%{opacity: 1;}
  20%{opacity: 0;}
  30%{opacity: 1;}
  40%{opacity: 0;}
  50%{opacity: 1;}
  60%{opacity: 0;}
  70%{opacity: 1;}
  80%{opacity: 0;}
  90%{opacity: 1;}
  100%{opacity: 0;}
}
@keyframes life_ss{
   0%{opacity: 0;}
  10%{opacity: 1;}
  20%{opacity: 0;}
  30%{opacity: 0;}
  40%{opacity: 1;}
  50%{opacity: 0;}
  60%{opacity: 1;}
  70%{opacity: 0;}
  80%{opacity: 1;}
  90%{opacity: 0;}
  100%{opacity: 1;}
}
#believe{
  animation-name: ss;
  animation-duration: 50s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
#life{
  animation-name: life_ss;
  animation-duration: 50s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.beianhao{
  text-align: center;
  color: white;
  position: absolute;
  bottom: 0;
  font-size: 10px;
  left: 45%;
  /* padding-bottom: 0; */
}
@media screen and (min-width: 1500px){
  #main{
  width: 100%;
  margin-top: 0;
  height: auto;
  background-image: url('~@/assets/home_img/star1.png');
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;
  animation-name: bg;
  animation-duration: 12s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  aspect-ratio: 19 / 10;
}
#believe{
  position: absolute;
  left: 10%;
  top: 42%;
}
#life{
  position: absolute;
  left: 30%;
  top: 65%;
}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  #main{
  width: 100%;
  margin-top: 0;
  height: auto;
  background-image: url('~@/assets/home_img/star1.png');
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;
  animation-name: bg;
  animation-duration: 12s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  aspect-ratio: 19 / 10;
}
#believe{
  width: 50%;
  position: absolute;
  left: 7%;
  top: 42%;
}
#life{
  width: 60%;
  position: absolute;
  left: 30%;
  top: 65%;
}
}
@media screen and (min-width: 960px) and (max-width:1199px){
  #main{
  width: 100%;
  margin-top: 0;
  height: auto;
  background-image: url('~@/assets/home_img/star1.png');
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;
  animation-name: bg;
  animation-duration: 12s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  aspect-ratio: 19 / 10;
}
#believe{
  width: 50%;
  position: absolute;
  left: 5%;
  top: 42%;
}
#life{
  width: 60%;
  position: absolute;
  left: 30%;
  top: 65%;
}
}
@media screen and (min-width: 768px) and (max-width:959px){
  #main{
  width: 100%;
  margin-top: 0;
  height: auto;
  background-image: url('~@/assets/home_img/star1.png');
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;
  animation-name: bg;
  animation-duration: 12s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  aspect-ratio: 19 / 10;
}
#believe{
  width: 50%;
  position: absolute;
  left: 5%;
  top: 42%;
}
#life{
  width: 60%;
  position: absolute;
  left: 30%;
  top: 65%;
}
}
@media screen and (min-width: 702px) and (max-width:767px){
  #main{
  width: 100%;
  margin-top: 0;
  height: 1000px;
  background-image: url('~@/assets/home_img/star1.png');
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;
  animation-name: bg;
  animation-duration: 12s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
#believe{
  width: 50%;
  position: absolute;
  left: 5%;
  top: 42%;
}
#life{
  width: 60%;
  position: absolute;
  left: 30%;
  top: 65%;
}
}
@media screen and (max-width:701px){
  #main{
  width: 100%;
  margin-top: 0;
  height: 790px;
  background-image: url('~@/assets/home_img/star1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  opacity: 1;
  animation-name: bg;
  animation-duration: 12s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
#believe{
  width: 50%;
  position: absolute;
  left: 7%;
  top: 42%;
}
#life{
  width: 60%;
  position: absolute;
  left: 30%;
  top: 65%;
}
}
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue